import React from 'react'
import logoColor from "../vectors/logo.svg"

export default function landingPage() {
  return (
    <div className='hero-container'>

      <h1>Üdvözöljük az Épületszimuláció.hu oldalon!</h1>

      <img src={logoColor} alt="logoColor" />
    </div>
  )
}
